import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var HardHatSVG = function HardHatSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M39.913,9h-3.08a2.006,2.006,0,0,0-2-2h-3a2,2,0,0,0-4,0h-3a2.006,2.006,0,0,0-2,2h-3.08a1.92,1.92,0,0,0-1.92,1.92V37.08A1.92,1.92,0,0,0,19.753,39h20.16a1.92,1.92,0,0,0,1.92-1.92V10.92A1.92,1.92,0,0,0,39.913,9Zm-2.08,14h-16a1,1,0,0,1,0-2h16a1,1,0,0,1,0,2Zm0-4h-16a1,1,0,0,1,0-2h16a1,1,0,0,1,0,2Zm0-4h-16a1,1,0,0,1,0-2h16a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M19.833,22.429a1.29,1.29,0,0,0,1.286-1.286V10.857a1.286,1.286,0,1,0-2.571,0V21.143A1.289,1.289,0,0,0,19.833,22.429Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M35.262,27.571V25A15.443,15.443,0,0,0,23.6,10.06a3.849,3.849,0,0,0-7.534,0A15.442,15.442,0,0,0,4.405,25v2.571a2.58,2.58,0,0,0-2.572,2.572v2.571a2.58,2.58,0,0,0,2.572,2.572H35.262a2.579,2.579,0,0,0,2.571-2.572V30.143A2.579,2.579,0,0,0,35.262,27.571ZM18.548,10.857a1.286,1.286,0,1,1,2.571,0V21.143a1.286,1.286,0,1,1-2.571,0ZM6.976,25a12.829,12.829,0,0,1,3.857-9.18v5.323a1.286,1.286,0,1,0,2.572,0V13.879a12.141,12.141,0,0,1,2.571-1.145v8.409a3.857,3.857,0,0,0,7.714,0V12.734a12.149,12.149,0,0,1,2.572,1.145v7.264a1.286,1.286,0,1,0,2.571,0V15.82A12.825,12.825,0,0,1,32.69,25v2.571H6.976Zm28.286,7.714H4.405V30.143H35.262Z"
  }));
};
HardHatSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
HardHatSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "General Manager")
};
export default withDetailedIcon(HardHatSVG);